import { Box, Button, Stack } from "@mui/material";

import {
  EVOTRUX_BORDER_GREY,
  EVOTRUX_BORDER_GREY_HOVER,
} from "constants/index";

import { QuoteFilterByShipmentNameTextField } from "../QuoteFilterByShipmentNameTextField";
import { QuoteSortBySelect } from "../QuoteSortBySelect";
import { QuoteStatusMultiSelect } from "../QuoteStatusMultiSelect";

interface Props {
  filters: QuoteFilters;
  onShipmentNameChange: (value: string) => void;
  onQuoteStatusChange: (value: string[]) => void;
  onSortByChange: (value: string) => void;
  morePanelOpen: boolean;
  onMoreToggle: VoidFunction;
  filterClearCount: number;
}

export function QuoteFilters(props: Props) {
  const {
    filters,
    onShipmentNameChange,
    onQuoteStatusChange,
    onSortByChange,
    morePanelOpen,
    onMoreToggle,
    filterClearCount,
  } = props;

  return (
    <Stack direction="row" spacing={1.5} alignItems="center">
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <QuoteFilterByShipmentNameTextField
          key={filterClearCount}
          shipmentName={filters.shipmentName ?? ""}
          onShipmentNameChange={onShipmentNameChange}
          sx={{ width: "100%" }}
        />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <QuoteStatusMultiSelect
          value={filters.quoteStatus ?? []}
          onChange={onQuoteStatusChange}
          width="100%"
        />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <QuoteSortBySelect
          value={filters.sortBy}
          onChange={onSortByChange}
          width="100%"
        />
      </Box>
      <Button
        variant="outlined"
        onClick={onMoreToggle}
        sx={{
          whiteSpace: "nowrap",
          flexShrink: 0,
          borderColor: EVOTRUX_BORDER_GREY,
          color: "text.primary",
          "&:hover": {
            borderColor: EVOTRUX_BORDER_GREY_HOVER,
            backgroundColor: "action.hover",
          },
        }}
      >
        {morePanelOpen ? "LESS" : "MORE"}
      </Button>
    </Stack>
  );
}
